<template>
    <div id="card_info" class="uk-card uk-card-default uk-card-body mbk_large_box_shadow">
        <h4 v-if="message">{{ message }}</h4>
        <p v-if="add_message">{{ add_message }}</p>
        <p v-if="resText" :class="{ 'uk-text-danger': resTextError }">{{ resText }}</p>
        <form @submit.prevent="submit"
              class="uk-form-stacked"
              id="mbk_form">
            <fieldset class="uk-fieldset">
                <label for="card_number" class="uk-form-label">{{$t("credit_card.card_number")}}</label>
                <div class="uk-form-controls">
                    <div class="uk-inline uk-width-1-1">
                        <span class="uk-form-icon" uk-icon="credit-card"></span>
                        <input v-mask="'####  ####  ####  ####'"
                               id="card_number"
                               @input="setNumber"
                               :value="form.number"
                               :disabled="formDisabled"
                               type="text"
                               class="uk-input"
                               inputmode="numeric"
                               placeholder="1234 5678 9123 4567" autofocus>
                    </div>
                </div>
                <small class="uk-text-danger" v-html="form.flattenErrors('number')"></small>
            </fieldset>
            <fieldset class="uk-fieldset">
                <label for="card_expiration_date"
                       class="uk-form-label">{{$t("credit_card.card_expiration_date")}}</label>
                <div class="uk-form-controls">
                    <div class="uk-inline uk-width-1-1">
                        <span class="uk-form-icon" uk-icon="calendar"></span>
                        <input @input="setValidThrough"
                               :value="form.validThrough"
                               v-mask="'## / ####'"
                               type="text"
                               class="uk-input"
                               id="card_expiration_date"
                               :disabled="formDisabled"
                               inputmode="numeric"
                               :placeholder="form.validThroughPlaceholder">
                    </div>
                </div>
                <small v-html="form.flattenErrors('validThrough')" class="uk-text-danger"></small>
            </fieldset>
            <fieldset class="uk-fieldset">
                <button :disabled="formDisabled" type="submit"
                        class="uk-button uk-button-primary uk-width-1-1">
                    {{ buttonCaption }}
                    <span v-if="processing" uk-spinner="ratio: 0.75"></span>
                </button>
            </fieldset>
        </form>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { mask }       from "vue-the-mask";
    import CardForm       from "@/utils/CardForm";

    export default {
        name: "CreditCardForm",
        props: {
            docsetID: { required: true, type: String }
        },
        computed: {
            ...mapGetters(["add_message", "message", "user"]),
            formDisabled() {
                return this.buttonState === "disabled";
            },
            buttonCaption() {
                if(this.processing){
                    return ""
                }
                return this.checked ? this.$t("credit_card.submit") : this.$t("credit_card.check");
            }
        },
        directives: { mask },
        data() {
            return {
                form: new CardForm(),
                buttonState: "enabled",
                resText: "",
                resTextError: false,
                checked: false,
                processing: false,
            };
        },
        methods: {
            // These duplications implemented because when you call directly
            // The methods themselves they will lose `this` context
            setNumber(e) {
                this.form.setNumber(e);
            },
            setValidThrough(e) {
                this.form.setValidThrough(e);
            },
            check() {
                return this.$http.post("/check-credit-card/", {
                    docsetID: this.docsetID,
                    code: this.user.pinCode,
                    ...this.form.serialize()
                }).then(res => {
                    this.resTextError = res.data["elkart_response"]["result"]["status"] !== 1;
                    if(res.data["elkart_response"]["result"]["status"] === 1) {
                        this.checked = true;
                        this.form.cardholder = res.data["elkart_response"]["result"]["message"];
                    }
                    this.resText = res.data["elkart_response"]["result"]["message"];
                }).catch(err => {
                    if (err.response.status >= 500) {
                        this.resText = err.response.data.message;
                        this.resTextError = true;
                        return
                    }
                    if (err.response.data["validationError"]) {
                        this.form.errors = err.response.data["validationError"];
                    }
                });
            },
            save() {
                return this.$http.post("/process-credit-card/", {
                    docsetID: this.docsetID,
                    code: this.user.pinCode,
                    ...this.form.serialize()
                }).then(res => {
                    this.buttonState = res.data["res_button_state"];
                    this.resText = res.data["res_text"];
                    this.resTextError = false;
                }).catch(err => {
                    if (err.response.status >= 500) {
                        this.resTextError = true;
                        this.resText = this.$t("error_500");
                        return
                    }
                    if (err.response.data["validationError"]) {
                        this.form.errors = err.response.data["validationError"];
                    }
                });
            },
            submit() {
                this.form.validate();
                if (
                    !this.form.isValid ||
                    this.buttonState === "disabled" ||
                    this.processing
                ) return;
                this.processing = true;
                (this.checked ? this.save() : this.check()).then(() => {
                    this.processing = false;
                });
            }
        }
    };
</script>

<style scoped>
    #card_info {
        max-width: 500px;
    }
</style>